import React from 'react';
import PropTypes from 'prop-types';
import DataTable from 'src/components/ui/data-table';

// Loose shapes for the two array props — DataTable itself isn't
// PropTypes-validated (src/components/ui is ESLint-ignored), so this is as
// specific as we can usefully be from here without duplicating its full
// column-config contract.
export const columnShape = PropTypes.shape({
  key: PropTypes.string,
  header: PropTypes.node,
  className: PropTypes.string,
  tooltip: PropTypes.bool,
  render: PropTypes.func,
});

export const candidateShape = PropTypes.shape({
  candidate_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  status: PropTypes.string,
});

// Thin shared wrapper around the app's DataTable, used by every secondary-
// flow tab component so pagination/loading wiring lives in one place
// instead of being copy-pasted across all six tabs. Tabs only differ in
// `columns` and `emptyState` — AssignmentPipeline.jsx owns the actual query
// and paging state and threads it down as props.
const PipelineDataTable = ({
  columns,
  candidates,
  isLoading,
  page,
  pageSize,
  totalPages,
  totalItems,
  onPageChange,
  onPageSizeChange,
  emptyState,
  rowClassName,
  onRowClick,
}) => (
  <DataTable
    className="border-border rounded-t-none"
    data={candidates}
    columns={columns}
    getRowId={(row) => row.candidate_id}
    hover
    stickyHeader
    loading={isLoading}
    pagination
    currentPage={page}
    totalPages={totalPages}
    pageSize={pageSize}
    totalItems={totalItems}
    onPageChange={onPageChange}
    onPageSizeChange={onPageSizeChange}
    emptyState={emptyState}
    rowClassName={rowClassName}
    onRowClick={onRowClick}
    // DataTable merges each column's own `className` (e.g. "text-sm", meant
    // for the body cell) into its header cell too, which was silently
    // overriding the header's intended small caps size with the body's
    // larger one — headerClassName is applied last, so it wins that merge.
    headerClassName="text-[10.5px]"
  />
);

PipelineDataTable.propTypes = {
  columns: PropTypes.arrayOf(columnShape).isRequired,
  candidates: PropTypes.arrayOf(candidateShape),
  isLoading: PropTypes.bool,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  emptyState: PropTypes.node,
  rowClassName: PropTypes.func,
  onRowClick: PropTypes.func,
};

PipelineDataTable.defaultProps = {
  candidates: [],
  isLoading: false,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  totalItems: 0,
  onPageChange: () => {},
  onPageSizeChange: () => {},
  emptyState: null,
  rowClassName: undefined,
  onRowClick: undefined,
};

export default PipelineDataTable;
